import * as React from "react"
import * as PropTypes from 'prop-types'

import { cn } from "@/lib/utils"
import { INPUT_FIELD_ERROR_CLASSNAME } from "@/constants/classname/classname"

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  hasError?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, hasError, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // text-primary ensures typed text is near-black (#0F172A) regardless of the
          // surrounding context. Without it the component inherits text-foreground which
          // resolves to white (#FFFFFF) in this app's light-mode theme — typed characters
          // become invisible on bg-background. WCAG AA: text-primary on bg-background =
          // 16.30:1 per brand-guide §1a certified pairings table.
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm text-primary ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focusRing focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-btn-secondary disabled:text-secondary",
          className,
          hasError ? INPUT_FIELD_ERROR_CLASSNAME : ''
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

Input.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  hasError: PropTypes.bool
}

Input.displayName = "Input"

export { Input }
